import { MyTaskService } from "@/service/MyTaskService";
import { HakenSyouninListReq, HakensakiShimeCheckData } from "@/types/MyTask";
import { computed, ref, Ref } from "vue";
/*
 * 派遣先上長承認グループの月締め情報を取得する
 */
export function useHakensakiShimeCheckListInit() {
  let loading = ref(0);
  let isListError = ref(false);

  // 読み込み中か判断する
  const isListLoading = computed(() => {
    return !(loading.value === 0 || isListError.value);
  });

  // 一覧取得
  const getList = async (params: HakenSyouninListReq, form: Ref<HakensakiShimeCheckData[]>) => {
    loading.value++;

    // API
    const srv = new MyTaskService();
    const res = await srv.getHakensakiShimeCheckList(params);

    if (res) {
      form.value = res;
    }
    loading.value--;
  };

  return {
    isListLoading,
    isListError,
    getList,
  };
}
